<style lang="scss">
  @import "@/assets/scss/vuexy/components/valueItem";

  .text-danger {
    color: '#EA5455'
  }
  .text-warning {
    color: '#FF9F43'
  }
  .text-success {
    color: '#28C76F'
  }
  .color-text-blue {
    color: #0cb0f1
  }
</style>
<template>
  <div class="p-2">
      <div class="device-info vx-col w-full">
          <div class="shadow-drop d-theme-dark-bg round" v-if="img !== undefined">
              <img :src="getImgUrl(img)" class="info-icon p-2 block" alt="ícono sensor"/>
          </div>
          <div class="device-text-container" v-if="!relativeTime">
              <span class="main-info" :class="this.alert">
                  {{ value }} <span>{{unit}}</span>
              </span>
              <span class="subtext-info" v-if="deviceType === 'V' || deviceType === 'C'">
                  {{message}} {{description}}
              </span>
              <span class="subtext-info" v-if="deviceType !== 'V' && deviceType !== 'C'">
                  {{description}} {{message}}
              </span>
          </div>
          <div class="device-text-container" v-if="relativeTime">
              <span class="main-info">
                  {{relativeTimeConvert(value)}}
              </span>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    value: String,
    unit: String,
    img: String,
    description: String,
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    warning: {
      type: String,
      default: ''
    },
    relativeTime: Boolean,
    deviceType: String
  },
  data () {
    return {
      alert: '',
      message: ''
    }
  },
  methods: {
    getImgUrl (name) {
      const val = parseFloat(this.value)
      const min = parseFloat(this.min)
      const max = parseFloat(this.max)
      const warning = parseFloat(this.warning)
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      if (this.min !== '' && this.max !== '') {
        let color = ''
        if (!warning) {
          if (val > max) {
            color = 'red'
            this.alert = 'text-danger'
            this.message = this.$t('Labels.HighRank')
          } else if (val >= min && val <= max) {
            color = 'green'
            this.alert = 'text-success'
            this.message = this.$t('Labels.CorrectRange')
          } else {
            color = 'blue'
            this.alert = 'color-text-blue'
            this.message = this.$t('Labels.LowRange')
          }
        } else {
          if (val <= min) {
            color = 'green'
            this.alert = 'text-success'
            this.message = (this.deviceType === 'V' ? this.$t('Labels.RiskFree2') : this.$t('Labels.Good'))
          } else if (val <= warning) {
            color = 'warning'
            this.alert = 'text-warning'
            this.message = (this.deviceType === 'V' ? this.$t('Labels.RiskModerate2') : this.$t('Labels.Bad'))
          } else if (val > warning) {
            color = 'red'
            this.alert = 'text-danger'
            this.message = (this.deviceType === 'V' ? this.$t('Labels.RiskHight2') : this.$t('Labels.Poor'))
          }
        }

        return images(`./${name}_${color}.svg`)
      } else {
        return images(`./${name}.svg`)
      }
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    }
  }
}
</script>
